import { AgentMessage } from '../../Core/Types/bizagent';
import './BizAgentMessage.scss';

interface BizAgentMessageProps {
	message: AgentMessage;
}

const BizAgentMessageComponent = ({ message }: BizAgentMessageProps) => {
	const isUser = message.messageType === 'USER';
	const displayText = isUser ? message.message : message.response;
	const timestamp = new Date(message.createdDate).toLocaleTimeString([], {
		hour: '2-digit',
		minute: '2-digit',
	});

	if (!displayText) return null;

	return (
		<div className={`biz-agent-message ${isUser ? 'user' : 'bot'}`}>
			<div className='biz-agent-message-content'>
				<div className='biz-agent-message-text'>{displayText}</div>
				<div className='biz-agent-message-meta'>
					<span className='biz-agent-message-time'>{timestamp}</span>
					{!isUser && message.responseTime && (
						<span className='biz-agent-message-response-time'>({message.responseTime}ms)</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default BizAgentMessageComponent;
